module.exports = __webpack_public_path__ + "img/bursting_from_boxes.35995bcd.jpg";